import React from 'react';
import {
    Container,
    GridHeader,
    HeaderArea,
    IconArea,
    Icon
} from './styles';

export default function Card(props) {
    const component = props.component;
    return (
        <Container>
            <GridHeader>
                <IconArea>
                    <Icon
                        src={`./assets/images/icons/` + props.icon}
                        width={props.hasWidth}
                        ac={props.ac}
                    />
                </IconArea>
                <HeaderArea>
                    {props.title ? props.title  : ""}
                </HeaderArea>
            </GridHeader>
            {component}
        </Container>
    );
}
